var warningsDone = [];

var __DEV__ = process.env.NODE_ENV === 'development';

/**
 * Throw a warning about something only once per key. Only warns in dev mode.
 */
function maybeWarn(key, warning, skipStack) {
  if (!__DEV__) {
    return;
  }

  if (warningsDone.indexOf(key) === -1) {
    warningsDone.push(key);
    console.warn('[warning]', skipStack ? warning : new Error(warning).stack);
  }
}
exports.maybeWarn = maybeWarn;



// WEBPACK FOOTER //
// /home/jenkins/agent/workspace/b-apps_b2c-site_b2c-site_develop/lib/maybe-warn.js